import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { queryClient } from "../../../utils/queryClient";
// prime react
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
// components
import { TableData } from "./TableData";
import Input from "../../../components/input/Input";
import Modal from "../../../components/modal/Modal";

import { getCostCenter } from "../../../services/CostCenter/getCostCenter";
import { postCostCenter } from "../../../services/CostCenter/postCostCenter";
import { getSchedules } from "../../../services/GlobalRoles/getSchedules";
import FileInput from "../../../components/input/FileInput";
import { postSchedulesExcel } from "../../../services/GlobalRoles/postSchedulesExcel";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";
import { Skeleton } from "primereact/skeleton";

const CostCenter = () => {
  usePermission("116"); //Visualizar Centro de Custos
  const { permissions } = useAppContext();

  const { data: schedules, refetch: refetchSchedule } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => getSchedules(),
    // retry: false,/
    // refetchOnWindowFocus: false,
    enabled: !!permissions?.includes("2"),
  });

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["cost-center"],
    queryFn: () => getCostCenter(),
    enabled: !!permissions?.includes("116"),
  });

  const form = useForm();
  const errors = form.formState.errors;

  const [dataTable, setDataTable] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleFileInput, setVisibleFileInput] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);

  const items = [
    {
      template: () => (
        <Link to={"/financial/costCenter"} className="p-breadcrumb-link">
          Centro de custo
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const handleOption = async (title) => {
    setVisibleFileInput(true);
  };
  const spreadsheet = [
    {
      label: "Baixar Modelo",
      icon: "fa fa-solid fa-download",
      command: () => requestFile(),
    },
    {
      label: "Cadastrar por Planilha",
      icon: "fa fa-upload",
      color: "success",
      disabled: schedules?.some(
        (schedule) => schedule.type === "excel_cost_center"
      ),
      command: () =>
        handleOption(`Planilha de Centro de Custos`, "cost_center"),
    },
  ];
  const sortCostCenters = (costCenters) => {
    const parseRef = (ref) => ref.split(".").map(Number); // Divide por '.' e converte para número
  
    return [...costCenters].sort((a, b) => {
      const aParts = parseRef(a.ref);
      const bParts = parseRef(b.ref);
  
      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const numA = aParts[i] || 0; // Se não houver mais partes, assume 0
        const numB = bParts[i] || 0;
        if (numA !== numB) return numA - numB;
      }
      return 0;
    });
  };
  

  useEffect(() => {
    if (!isLoading && data) {
      setDataTable(sortCostCenters(data || []));
    }
  }, [data, isLoading]);
  

  async function requestFile() {
    var a = document.createElement("a");
    a.href =
      "https://walletlote-arquivos.s3.amazonaws.com/ibsystem/modelo_centro_custo.xlsx";
    a.click();
  }

  async function uploadFile() {
    const excelUpload = document.getElementById("excelUpload");
    excelUpload.click();
  }

  const transformJson = (jsonData) => {
    return jsonData.slice(4).map((row) => {
      return {
        ref: row["Tabela para cadastro de Centro De Custo"] || "",
        desc: row["__EMPTY"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };

  const handleFileChange = async (event) => {
    const notification = toast.loading(
      "Enviando seus dados, por favor aguarde..."
    );

    const base64Data = selectedFile;

    // Função para converter base64 para ArrayBuffer
    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64.split(",")[1]); // Remove o prefixo "data:application/vnd..."
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes.buffer;
    };

    const arrayBuffer = base64ToArrayBuffer(base64Data);

    // Usando XLSX para ler o ArrayBuffer e converter o Excel em JSON
    const workbook = XLSX.read(arrayBuffer, { type: "array" });

    // Pegando a primeira planilha
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Converte a planilha em JSON
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    const transformedData = transformJson(jsonData);

    // console.log(transformedData);

    const obj = {
      datas: transformedData,
      type_excel: "cost_center",
    };

    const res = await postSchedulesExcel(obj);
    refetch();
    if (res.success) {
      toast.update(notification, {
        render: res.success.toString(),
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
    } else {
      toast.update(notification, {
        render: "Agendamento de Planilha Pendente.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
    refetchSchedule();
    setSelectedFile([]);
    setVisibleFileInput(false);
  };

  // post cost center
  const { mutateAsync: postCostCenterFn } = useMutation({
    mutationFn: postCostCenter,
    onSuccess(dataCost, variables) {
      queryClient.setQueryData(["cost-center"], (data) => {
        return [...data, dataCost.data];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    //    console.log(data);

    const notification = toast.loading("Cadastrando...");
    try {
      const response = await postCostCenterFn(data);
      //      console.log(response);

      // setDataTable(obj);

      toast.update(notification, {
        render: "Centro de custos cadastrado com sucesso.",
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });

      setVisible(false);
    } catch (e) {
      const errorMessage = e.message || "Ocorreu um erro inesperado.";
      toast.update(notification, {
        render: errorMessage,
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } finally {
      setLoading(false);
      form.reset({ ref: "", desc: "" });
    }
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="row p-0">
          <div className="col-md-4">
            <BreadCrumb
              model={items}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
            <Modal
              visible={visibleFileInput}
              dynamicTitle={`Planilha de Centro de Custos`}
              onHide={(e) => setVisibleFileInput(false)}
            >
              <FileInput
                isMultiple={false}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                onConfirmButton={handleFileChange}
                buttonConfirm={true}
                type="file"
                base64={true}
                typeFile=".xlsx,.xls"
                name="excelUpload"
                id="excelUpload"
                title="Inserir Planilha"
                icon="fa-rotate-left"
              />
            </Modal>
          </div>
          <div className="col-md-8 text-end p-0">
            <div className="row justify-content-end pb-3">
              {permissions &&
                permissions.includes("120") && ( // Cadastrar Centro de Custos por Planilhas
                  <div className="col-md-3">
                    <SplitButton
                      label="Planilhas"
                      icon="fa fa-file"
                      model={spreadsheet}
                      rounded
                      className="w-100 pb-2 meuComponente"
                    />
                  </div>
                )}
              {permissions &&
                permissions.includes("117") && ( // Cadastrar Centro de Custos
                  <div className="col-md-3">
                    <Button
                      rounded
                      severity="success"
                      label="Novo"
                      icon="fa fa-plus"
                      onClick={() => setVisible(true)}
                      className="p-inputtext-sm me-2 m-auto w-100"
                    />
                  </div>
                )}
            </div>
          </div>

          <Modal
            visible={visible}
            dynamicTitle={"Novo centro de custo"}
            onHide={() => setVisible(false)}
            closable={true}
          >
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row px-3">
                <div className="col-md-5 mb-3">
                  <Input
                    control={form.control}
                    name="ref"
                    className="w-100"
                    errors={errors}
                    label="Ref"
                    isRequired={true}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    control={form.control}
                    name="desc"
                    className="w-100"
                    errors={errors}
                    label="Descrição"
                    isRequired={true}
                  />
                </div>
                <div className="col-md-3 pt-3">
                  <Button
                    rounded
                    type="submit"
                    loading={loading}
                    label="Cadastrar"
                    icon="fa fa-plus"
                    className="p-inputtext-sm m-auto"
                  />
                </div>
              </div>
            </form>
          </Modal>
        </div>

        <input
          type="file"
          name="excelUpload"
          id="excelUpload"
          onChange={handleFileChange}
          hidden
        />
        {isLoading && <Skeleton width="100%" height={300} />}
        {!isLoading && <TableData dataTable={dataTable} />}
      </div>
    </>
  );
};

export default CostCenter;
